import React, { useEffect, useState } from 'react';
import { Icon } from 'react-icons-kit'
import { ic_add_box } from 'react-icons-kit/md/ic_add_box'
import { ic_search } from 'react-icons-kit/md/ic_search'
import { ic_delete } from 'react-icons-kit/md/ic_delete'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import $ from 'jquery'

import NavBar from '../components/NavBar'
import FrTable from '../components/FrTable'
import UserOptions from '../components/UserOptions'
import FrLoading from '../components/FrLoading'
import FooterDelphus from '../components/FooterDelphus'
import FrDatePicker from '../components/FrDatePicker'
import Dialog from '@material-ui/core/Dialog';
import { colors } from '../utils/vars'
import FrTextInput from '../components/FrTextInput'


import api from '../services/api'
import { paramsToObject, formToObject, populateForm, objectToQueryString, isEmpty, getUserCode } from '../utils/functions'

import './styles/DefaultMainScreen.css';
import './styles/Manut.css';

const swal = withReactContent(Swal)

function Retornos(props) {
  const [data, setData] = useState([])
  const [filter, setFilter] = useState({})
  const [filtered, setFiltered] = useState(false)
  const [enableAdd, setenableAdd] = useState('N')
  const [showModal, setShowModal] = useState(false)
  const [arquivo, setArquivo] = useState('')
  const [arq, setArq] = useState('')

  const columns = [
    { id: 'data_geracao', date: true, numeric: false, label: 'Data Geração', align: 'left', minWidth: 50 },
    { id: 'nomeusu', numeric: false, label: 'Usuário', align: 'left', minWidth: 100 },
    { id: 'nomefpg', numeric: false, label: 'Banco/Conta', align: 'left', minWidth: 100 },

  ]

  const selectFile = (e) => {
    e.preventDefault();
    $('#html').click();
  }

  const handleFile = (e) => {
    e.preventDefault()
    let file = e.target.files[0];
    if (file) {
      setArq(file)
      setArquivo(file.name)
    } else {
      setArq(null)
      setArquivo('Nenhum arquivo selecionado')
    }

  }



  // 25 - ITAU CLUBE
  // 29 - SANTANDER
  // 24 - BB
  // 21 - BANRISUL
  // 30 - ITAÚ VIDA
  // 23 - BRADESCO
  // 22 - CEF

  useEffect(() => {
    const fetchData = async () => {
      swal.fire({
        html: <FrLoading text="Carregando..." />,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false
      })

      let tela = 'Retornos Bancários'
      setenableAdd(await api.getAcessos(tela, 'Inclusao'))

      const urlParams = new URLSearchParams(window.location.search);
      let query = paramsToObject(urlParams)

      setFilter(query)
      populateForm(document.getElementById('searchForm'), query)

      swal.close()
      if (query.buscar === 'true') {
        let event = new Event('build');
        getData(event)
      }
    }

    fetchData()
  }, [])

  function getData(e) {
    e.preventDefault()
    var formData = new FormData(document.getElementById('searchForm'))
    var queryObject = formToObject(formData)
    if (!isEmpty(queryObject)) {
      queryObject.buscar = true
      setFiltered(true)
      window.history.replaceState({ filtered: true }, 'filter', "/salute/retornos?" + objectToQueryString(queryObject));
      swal.fire({
        html: <FrLoading text="Buscando dados..." />,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false
      })
      api.get('/retornos', { params: queryObject }).then(r => {
        setData(r.data)
        swal.close()
      })
    } else {
      swal.fire({
        title: 'Nenhum filtro informado!',
        html: '<p>Informe ao menos um filtro para realizar a busca.',
        icon: 'warning'
      })

    }
  }

  function clearForm(e) {
    e.preventDefault();
    window.history.replaceState({ filtered: false }, 'filter', '/salute/retornos');
    document.getElementById('searchForm').reset()
    setFilter({})
  }

  function geraCobranca(e) {
    e.preventDefault();
    setArquivo('')
    setShowModal(true)
  }

  function confirmaModal(e) {
    e.preventDefault();


    if (arquivo) {
      const auxValues = { ...filter };
      auxValues.fk_usu = getUserCode()
      let formData = new FormData();
      try {
        formData.append('file', arq, arquivo)
      } catch {

      }

      try {
        api.post('/retornos/leRetorno', formData).then(async r => {
          if ((r.status === 200) && (r.data.indexOf('Erro') == -1)) {
            swal.fire({
              customClass: {
                container: 'my-swal'
              },

              title: `<h2 style='color:${colors.info900}'>ATENÇÃO</h2>`,
              html: `<p style='color: ${colors.info900}'>Confirma leitura do arquivo ` + r.data + `?<p>`,
              icon: 'warning',
              color: colors.info900,
              showCancelButton: true,
              confirmButtonColor: colors.success500,
              cancelButtonColor: colors.danger500,
              confirmButtonText: 'Sim',
              cancelButtonText: 'Não'
            }).then((result) => {
              if (result.value) {
                swal.fire({
                  customClass: {
                    container: 'my-swal'
                  },
                  html: <FrLoading text="Lendo arquivo..." />,
                  showConfirmButton: false,
                  allowOutsideClick: false,
                  allowEscapeKey: false
                })

                api.post('/retornos/geraRetorno?fk_usu=' + getUserCode(), formData).then(async r => {
                  if (r.status === 200) {
                    swal.fire({
                      customClass: {
                        container: 'my-swal'
                      },
                      html: `<p style='color: ${colors.info900}'>Arquivo lido com sucesso!</p>`,
                      icon: 'success',
                    }).then((result) => {
                      if (result.value) {
                        setShowModal(false)
                      }
                    })
                  }
                })
              }
            })
          } else
            swal.fire({
              customClass: {
                container: 'my-swal'
              },

              title: 'Erro!',
              html: '<p>' + r.data,
              icon: 'warning'
            })

        })

      } catch (error) {
        swal.fire({
          customClass: {
            container: 'my-swal'
          },

          title: 'Erro!',
          html: '<p>' + error,
          icon: 'warning'
        })
      }

    } else
      swal.fire({
        customClass: {
          container: 'my-swal'
        },

        title: 'Informe o arquivo!',
        html: '<p>Informe o arquivo!',
        icon: 'warning'
      })

  }

  function fechaModal(e) {
    e.preventDefault();
    setShowModal(false)
  }

  const handleChange = (e) => {
    if (e.target.name == 'arquivo')
      setArquivo(e.target.value)
    else {
      const auxValues = { ...filter };
      switch (e.target.name) {
        default:
          auxValues[e.target.name] = e.target.value;
      }
      setFilter(auxValues);
    }
  };


  return (
    <div className="Manut">
      <NavBar />
      <div className="ManutContent">
        <div className="defaultHeader">
          <h3>Retornos Bancários</h3>
          <UserOptions temaEscuro={props.temaEscuro} setTemaEscuro={props.setTemaEscuro} />
        </div>
        <br />
        <div className="filtersDiv">
          <form id="searchForm" onSubmit={getData}>
            <div>
              <FrDatePicker
                value={(filter.dataini || '').split('T')[0]}
                name="dataini"
                id="dataini"
                color="#49573B"
                label="Período Geração"
                variant="outlined"
                size="small"
                style={{ width: 190 }}
                onChange={handleChange}
              />

              <label style={{ paddingRight: '7px', paddingTop: '7px' }}>a</label>

              <FrDatePicker
                value={(filter.datafim || '').split('T')[0]}
                name="datafim"
                id="datafim"
                color="#49573B"
                variant="outlined"
                size="small"
                style={{ width: 190 }}
                onChange={handleChange}
              />

            </div>
            <div>
              <button onClick={getData}>
                <Icon icon={ic_search} size={18} />
                Pesquisar
              </button>
              <button onClick={clearForm}>
                <Icon icon={ic_delete} size={18} />
                Limpar
              </button>
              {enableAdd !== 'S' ? '' :
                <button style={{ width: '200px' }} onClick={geraCobranca}>
                  <Icon icon={ic_add_box} size={18} />
                  Ler Retorno
                </button>
              }

            </div>
          </form>
        </div>
        <br />

        <div>
          <Dialog aria-labelledby="simple-dialog-title" open={showModal} maxWidth={'lg'}>
            <div className="modalContent">

              <input
                type="file"
                name="arquivo"
                id="html"
                accept=".txt"
                onChange={handleFile}
                style={{ display: 'none' }}
              />


              <FrTextInput
                value={arquivo || ''}
                onChange={handleChange}
                name="arquivo"
                id="arquivo"
                color="#528b46"
                label="Arquivo"
                variant="outlined"
                size="small"
                disabled
                required
                style={{ width: 300 }}
              />
              <button type="file" className="selectFileButton" onClick={selectFile}>
                Escolher Arquivo
              </button>


            </div>

            <div className="FrModalFooter">
              <div className="FrModalButtonsDiv">
                <button onClick={confirmaModal}> Confirmar </button>
                <button onClick={fechaModal}> Sair </button>
              </div>
            </div>

          </Dialog>
        </div>


        <div className={"tableDiv" + (props.frame && data.length > 0 ? '-frame' : '')}>
          <FrTable detail readOnly={'S'} startOrderBy={'data_geracao'} retornos width={50} regName="retornos" frame={props.frame} columns={columns} searched={filtered} codeName="pk_ret" page={'retornos'} data={data} />

        </div>
        <FooterDelphus />
      </div>
    </div>
  );
}

export default Retornos;